module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_c('div', {
    staticClass: "head-modal row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctn-custom-label"
  }, [_c('label', [_vm._v("Type de document")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "selected": _vm.type,
      "solo": true,
      "items": _vm.docTypeList
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui default-form-ui"
  }, [_c('div', {
    staticClass: "ctn-form-element"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nom du document")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-form-element margin"
  }, [((_vm.type !== 'Autres Documents' || (_vm.type === 'Autres Documents' && !_vm.confidential))) ? _c('custom-select-user', {
    attrs: {
      "items": _vm.clients
    },
    model: {
      value: (_vm.client),
      callback: function($$v) {
        _vm.client = $$v
      },
      expression: "client"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-form-element margin"
  }, [(_vm.type === 'Mes Justificatifs d\'identité') ? _c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.listOfJustificatifs
    },
    model: {
      value: (_vm.typeOfJustificatif),
      callback: function($$v) {
        _vm.typeOfJustificatif = $$v
      },
      expression: "typeOfJustificatif"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.type === 'Autres Documents') ? _c('div', {
    staticClass: "check-container row"
  }, [_c('radio-box', {
    attrs: {
      "value": _vm.confidential
    },
    on: {
      "change": function($event) {
        _vm.confidential = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_vm._v("\n\t\t\t\t\tVoulez vous que votre document soit privé\n\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (!_vm.needTwoInput) ? _c('drag-and-drop', {
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.needTwoInput) ? _c('drag-and-drop', {
    model: {
      value: (_vm.fileRecto),
      callback: function($$v) {
        _vm.fileRecto = $$v
      },
      expression: "fileRecto"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.needTwoInput) ? _c('drag-and-drop', {
    model: {
      value: (_vm.fileVerso),
      callback: function($$v) {
        _vm.fileVerso = $$v
      },
      expression: "fileVerso"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("Enregistrer")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-header-title column"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n\t\t\t\tAjouter un document\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\t\tEnvoyez des documents à votre client\n\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28329184"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/AddDocument.vue
// module id = 1090
// module chunks = 0